import { FALLBACK_CONSULTING } from './consulting-data';

export const ConsultingHero = ({ cms }) => (
  <>
    <section className="bg-gradient-to-br from-[#0F766E] to-[#0D9488] relative overflow-hidden" data-testid="consulting-hero">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.04) 1px, transparent 1px)', backgroundSize: '72px 72px' }} />
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-16 items-end">
          <div className="lg:pb-8">
            <div className="inline-flex items-center gap-2 text-[#F59E0B] text-xs font-semibold tracking-[0.22em] uppercase mb-7">
              <span className="w-7 h-[1.5px] bg-[#F59E0B]" /> Cabinet de conseil - Papeete, Polynésie française
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] font-bold text-white leading-[1.08] mb-6 tracking-tight" data-testid="hero-title">
              Structurez, sécurisez,<br />
              <span className="text-[#F59E0B] italic">développez</span><br />
              avec un partenaire<br />qui connaît le fenua.
            </h1>
            <p className="text-base text-white/60 leading-relaxed max-w-[460px]">
              AERH Consulting accompagne les dirigeants de TPE et PME sur leurs enjeux de création, d'organisation, de gestion et de sécurisation RH - avec une maîtrise approfondie du droit, de la fiscalité et des réalités économiques de la Polynésie française.
            </p>
          </div>
          <div>
            <div className="bg-black/20 border-t border-l border-white/10 rounded-t-xl grid grid-cols-2 overflow-hidden" data-testid="hero-stats">
              {(cms.hero?.stats || FALLBACK_CONSULTING.hero.stats).map((s, i) => (
                <div key={i} className="p-7 border-r border-b border-white/10 last:border-r-0 [&:nth-child(even)]:border-r-0">
                  <p className="text-2xl font-bold text-[#F59E0B] leading-none mb-1.5">{s.n}</p>
                  <p className="text-[11px] text-white/45 leading-snug">{s.l}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="bg-slate-200 py-9 border-b border-slate-300" data-testid="refs-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap items-center gap-6">
        <span className="text-[10px] font-semibold tracking-[0.18em] uppercase text-gray-500 whitespace-nowrap">Ils nous font confiance</span>
        <div className="w-px h-7 bg-slate-300 hidden sm:block" />
        <div className="flex flex-wrap gap-2">
          {(cms.références?.items || FALLBACK_CONSULTING.références.items).map(name => (
            <span key={name} className="text-xs font-medium px-3.5 py-1.5 rounded-full border transition-colors bg-white border-gray-200 text-gray-600 hover:border-[#F59E0B] hover:text-gray-800">
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  </>
);
